import React, { useState } from 'react';

import EductionModuleItem from '../../../components/EductionModuleItem';
import Popup from '../../../components/Popup';

const eductionItemList=[
    {
        imgName: 'eduction_btm_1.png',
        title: '生涯规划比赛',
        contentPosition: 'left',
        content: `
                <p>“选考在线”每年发起举办针对高中生的生涯规划比赛，旨在引导广大学生树立正确的成长观、人生观，科学合理地规划高中阶段的学习和生活，增强主动规划、自主发展的意识，逐步提升生涯规划能力。</p>
                <p>累计参赛学校百余所，观摩人数千余人，平均每场比赛网络直播观看人数50余万。</p>
                `
    },
    {
        imgName: 'eduction_btm_2.png',
        title: '生涯规划课比赛',
        contentPosition: 'left',
        content: `
                <p>“选考在线”每年发起举办针对高中生涯老师的生涯规划课比赛，举办大赛的目的是传播与普及生涯规划知识，进一步推进浙江省普通高中学校生涯教育工作。</p>
                <p>累计参赛学校百余所，观摩人数千余人，累计网络直播观看人数100余万。</p>`
    },
    {
        imgName: 'eduction_btm_3.png',
        title: '升学规划导师培训班',
        contentPosition: 'right',
        content: `
                <p>自2017年浙江新高考政策落地实施以来，“选考在线”发起主办多届浙江省高考升学研讨会、志愿填报研讨会、生涯规划教育发展论坛等会议。会议通过邀请教育专家、高校招生负责老师、资深志愿填报与职业规划师等多领域专业人士，为升学机构从业人员及学生和家长提供最新的升学政策解读、高校录取趋势分析以及不同行业就业前景展望。</p>`
    },
    {
        imgName: 'eduction_btm_4.png',
        title: '高考升学研讨会',
        contentPosition: 'right',
        content: `
                    <p>截止目前，“选考在线”已成功举办20余期高中生生涯导师培训，培训内容包括：“新高考政策与学业规划”、“三位一体与志愿填报”、“7选3选科决策”、“大类招生与自主招生”、“多元升学途径”等。</p>
                    <p>累计培训优秀生涯导师800余人。</p>
                `
    },
    {
        imgName: 'eduction_btm_5.png',
        title: '精英咨询师培养计划',
        contentPosition: 'left',
        content: `<p>“选考在线”精英咨询师培养计划的初衷是提高升学规划与志愿填报行业整体的服务水平，培养高水准的能为考生提供高质量升学规划服务和志愿填报服务的咨询师。</p>`
    },
]

export const EductionModule = (props) => {

    const [ showImgLook, setShowImgLook ] = useState(false);
    const [ imgUrl, setImgUrl ] = useState('')

    const handleSetImgLook=(imgName="")=>{
        if(imgName){
            setShowImgLook(true);
            setImgUrl(imgName);
        }else{
            setShowImgLook(false);
            setImgUrl('');
        }
    }

    return(
        <div className="four-eduction">
            <div className="four-right-top">
                <img src={require('../../../assets/images/eduction_top.jpg')}/>
            </div>
            <div className="four-right-bottom shadow">
                {eductionItemList.map((item,index)=>(<EductionModuleItem key={index} imgName={item.imgName} title={item.title} content={item.content} contentPosition={item.contentPosition} clickImg={()=>handleSetImgLook(item.imgName)}/>))}
            </div>
            <Popup isShow={showImgLook} clickMask={()=>handleSetImgLook()}>
                {showImgLook ? <img src={require(`../../../assets/images/${imgUrl}`)}/>:null}
            </Popup>
        </div>
    )
}

export default EductionModule;